module.exports = __webpack_public_path__ + "static/media/payby-logo.aa3024cc.svg";